import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { RootState } from "../../../globals";
import AuthService from "../../../services/auth.service";
import "./portal.css";

/*
	Mi Perfil del alumno (2026-10-21): sus datos de acceso y Cambiar Contraseña, con la actual o, si no la recuerda,
	con un código a su WhatsApp. Al cambiarla se cierran sus otras sesiones; esta sigue abierta.
*/
const MiPerfil: React.FC = () => {
	const usuario: any = useSelector((state: RootState) => state.rootReducer.sessionState.user)
	const [conCodigo, setConCodigo] = useState<boolean>(false)
	const [aviso, setAviso] = useState<string | null>(null)
	const [actual, setActual] = useState("")
	const [codigo, setCodigo] = useState("")
	const [clave, setClave] = useState("")
	const [otra, setOtra] = useState("")
	const [error, setError] = useState<string | null>(null)
	const [listo, setListo] = useState<string | null>(null)
	const [ocupado, setOcupado] = useState(false)
	const [ver, setVer] = useState(false)
	//Lo actual de la cuenta (no lo guardado al entrar) y si ya tiene contraseña (QA 2026-10-21).
	const [cuenta, setCuenta] = useState<{ nombre: string, correo: string | null, tieneClave: boolean } | null>(null)
	useEffect(() => {
		let vivo = true
		AuthService.miCuenta().then((r) => { if (vivo) setCuenta(r.data) }).catch(() => { /* se queda con lo de la sesión */ })
		return () => { vivo = false }
	}, [listo])
	const sinClave = cuenta !== null && !cuenta.tieneClave

	const textoDe = (x: any, porDefecto: string) => x?.response?.data?.message || porDefecto

	const pedirCodigo = async () => {
		setOcupado(true); setError(null); setListo(null)
		try {
			const r = await AuthService.codigoPerfil()
			setConCodigo(true)
			setAviso("Te mandamos un código por WhatsApp al número que termina en " + String(r.data.terminacion || "").replace(/\D/g, "") + ".")
		} catch (x: any) {
			setError(textoDe(x, "No se pudo mandar el código. Intenta otra vez en unos minutos."))
		} finally {
			setOcupado(false)
		}
	}

	const guardar = async (e: React.FormEvent) => {
		e.preventDefault()
		if (!sinClave && !conCodigo && actual === "") { setError("Escribe tu contraseña actual, o pide un código por WhatsApp."); return }
		if (conCodigo && codigo.length !== 6) { setError("Escribe el código de 6 dígitos que te llegó por WhatsApp."); return }
		if (clave.length < 8) { setError("La contraseña nueva necesita al menos 8 caracteres."); return }
		if (clave !== otra) { setError("Las dos contraseñas no coinciden."); return }
		setOcupado(true); setError(null); setListo(null)
		try {
			const r = await AuthService.cambiarClave(clave, otra, conCodigo || sinClave ? undefined : actual, conCodigo ? codigo : undefined)
			setListo(r.data.message || "Listo, tu contraseña quedó guardada.")
			setActual(""); setCodigo(""); setClave(""); setOtra(""); setConCodigo(false); setAviso(null)
		} catch (x: any) {
			setError(textoDe(x, "No se pudo guardar. Revisa tu conexión e intenta otra vez."))
		} finally {
			setOcupado(false)
		}
	}

	const nombre = cuenta?.nombre || [usuario?.firstName, usuario?.lastName].filter(Boolean).join(" ")
	const correo = cuenta ? cuenta.correo : usuario?.email

	return (
		<div className="pt">
			<div className="ptPagina ptUna">
				<div className="ptColumna">
					<h1 className="ptH1">Mi Perfil</h1>
					<div className="ptTarjeta">
						<div className="ptDato">
							<span className="ptTenue ptChico">Nombre</span>
							<span className="ptLinea">{nombre || "—"}</span>
						</div>
						<div className="ptDato">
							<span className="ptTenue ptChico">Correo</span>
							<span className="ptLinea ptPerfilCorreo">{correo || "Sin correo: entras con tu número de WhatsApp"}</span>
						</div>
					</div>

					<h2 className="ptH2">{sinClave ? "Crea Tu Contraseña" : "Cambiar Contraseña"}</h2>
					<form className="ptTarjeta ptPerfilForma" onSubmit={guardar} noValidate>
						{sinClave ? (
							<div className="ptChico">Todavía no tienes contraseña. Créala aquí: después entras con tu número de WhatsApp (o tu correo) y ella.</div>
						) : conCodigo ? (
							<>
								{aviso ? <div className="ptChico">{aviso}</div> : null}
								<label className="ptCampo">
									<span>Código de WhatsApp</span>
									<input inputMode="numeric" autoComplete="one-time-code" maxLength={14} value={codigo} disabled={ocupado}
										onChange={(e) => setCodigo(e.target.value.replace(/\D/g, "").slice(0, 6))} />
								</label>
							</>
						) : (
							<label className="ptCampo">
								<span>Contraseña actual</span>
								<input type={ver ? "text" : "password"} autoComplete="current-password" value={actual} disabled={ocupado}
									onChange={(e) => setActual(e.target.value)} />
							</label>
						)}
						<label className="ptCampo">
							<span>Contraseña nueva (mínimo 8)</span>
							<input type={ver ? "text" : "password"} autoComplete="new-password" maxLength={50} value={clave} disabled={ocupado}
								onChange={(e) => setClave(e.target.value)} />
						</label>
						<label className="ptCampo">
							<span>Repítela</span>
							<input type={ver ? "text" : "password"} autoComplete="new-password" maxLength={50} value={otra} disabled={ocupado}
								onChange={(e) => setOtra(e.target.value)} />
						</label>
						<button type="button" className="ptEnlace ptVer" onClick={() => setVer(!ver)}>{ver ? "Ocultar Contraseñas" : "Mostrar Contraseñas"}</button>
						{error ? <div className="ptPerfilError" role="alert">{error}</div> : null}
						{listo ? <div className="ptPerfilListo">{listo}</div> : null}
						<div className="ptAcciones">
							<button type="submit" className="ptBoton" disabled={ocupado}>{ocupado ? "Guardando…" : "Guardar Contraseña"}</button>
							{sinClave ? null : conCodigo
								? <button type="button" className="ptEnlace" disabled={ocupado} onClick={pedirCodigo}>Mandar Otro Código</button>
								: <button type="button" className="ptEnlace" disabled={ocupado} onClick={pedirCodigo}>No La Recuerdo: Mándame Un Código</button>}
						</div>
					</form>
				</div>
			</div>
		</div>
	)
}

export default MiPerfil
